"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The SubscriptionType model module.
 * @module model/SubscriptionType
 * @version 1.1.3-alpha.1
 */
class SubscriptionType {
  /**
   * Constructs a new <code>SubscriptionType</code>.
   * @alias module:model/SubscriptionType
   * @param sorting_order {Number} 
   * @param title {String} 
   * @param duration {Number} 
   * @param max_file_size {Number} 
   * @param max_total_size {Number} 
   * @param max_uploads {Number} 
   * @param user_limit {Number} 
   * @param is_trial {Boolean} 
   * @param adscores_accessible {Boolean} 
   * @param zoom_meeting_enabled {Boolean} 
   * @param id {String} 
   * @param created_at {String} 
   * @param updated_at {String} 
   */
  constructor(sorting_order, title, duration, max_file_size, max_total_size, max_uploads, user_limit, is_trial, adscores_accessible, zoom_meeting_enabled, id, created_at, updated_at) {
    SubscriptionType.initialize(this, sorting_order, title, duration, max_file_size, max_total_size, max_uploads, user_limit, is_trial, adscores_accessible, zoom_meeting_enabled, id, created_at, updated_at);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, sorting_order, title, duration, max_file_size, max_total_size, max_uploads, user_limit, is_trial, adscores_accessible, zoom_meeting_enabled, id, created_at, updated_at) {
    obj['sorting_order'] = sorting_order;
    obj['title'] = title;
    obj['duration'] = duration;
    obj['max_file_size'] = max_file_size;
    obj['max_total_size'] = max_total_size;
    obj['max_uploads'] = max_uploads;
    obj['user_limit'] = user_limit;
    obj['is_trial'] = is_trial;
    obj['adscores_accessible'] = adscores_accessible;
    obj['zoom_meeting_enabled'] = zoom_meeting_enabled;
    obj['id'] = id;
    obj['created_at'] = created_at;
    obj['updated_at'] = updated_at;
  }

  /**
   * Constructs a <code>SubscriptionType</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SubscriptionType} obj Optional instance to populate.
   * @return {module:model/SubscriptionType} The populated <code>SubscriptionType</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SubscriptionType();
      if (data.hasOwnProperty('sorting_order')) {
        obj['sorting_order'] = _ApiClient.default.convertToType(data['sorting_order'], 'Number');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = _ApiClient.default.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('duration')) {
        obj['duration'] = _ApiClient.default.convertToType(data['duration'], 'Number');
      }
      if (data.hasOwnProperty('max_file_size')) {
        obj['max_file_size'] = _ApiClient.default.convertToType(data['max_file_size'], 'Number');
      }
      if (data.hasOwnProperty('max_total_size')) {
        obj['max_total_size'] = _ApiClient.default.convertToType(data['max_total_size'], 'Number');
      }
      if (data.hasOwnProperty('max_uploads')) {
        obj['max_uploads'] = _ApiClient.default.convertToType(data['max_uploads'], 'Number');
      }
      if (data.hasOwnProperty('user_limit')) {
        obj['user_limit'] = _ApiClient.default.convertToType(data['user_limit'], 'Number');
      }
      if (data.hasOwnProperty('price_prepaid')) {
        obj['price_prepaid'] = _ApiClient.default.convertToType(data['price_prepaid'], 'Number');
      }
      if (data.hasOwnProperty('price_subscription')) {
        obj['price_subscription'] = _ApiClient.default.convertToType(data['price_subscription'], 'Number');
      }
      if (data.hasOwnProperty('is_trial')) {
        obj['is_trial'] = _ApiClient.default.convertToType(data['is_trial'], 'Boolean');
      }
      if (data.hasOwnProperty('adscores_accessible')) {
        obj['adscores_accessible'] = _ApiClient.default.convertToType(data['adscores_accessible'], 'Boolean');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = _ApiClient.default.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('zoom_meeting_enabled')) {
        obj['zoom_meeting_enabled'] = _ApiClient.default.convertToType(data['zoom_meeting_enabled'], 'Boolean');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('created_at')) {
        obj['created_at'] = _ApiClient.default.convertToType(data['created_at'], 'String');
      }
      if (data.hasOwnProperty('created_by')) {
        obj['created_by'] = _ApiClient.default.convertToType(data['created_by'], 'String');
      }
      if (data.hasOwnProperty('date_created')) {
        obj['date_created'] = _ApiClient.default.convertToType(data['date_created'], 'String');
      }
      if (data.hasOwnProperty('time_created')) {
        obj['time_created'] = _ApiClient.default.convertToType(data['time_created'], 'String');
      }
      if (data.hasOwnProperty('updated_at')) {
        obj['updated_at'] = _ApiClient.default.convertToType(data['updated_at'], 'String');
      }
      if (data.hasOwnProperty('updated_by')) {
        obj['updated_by'] = _ApiClient.default.convertToType(data['updated_by'], 'String');
      }
      if (data.hasOwnProperty('date_updated')) {
        obj['date_updated'] = _ApiClient.default.convertToType(data['date_updated'], 'String');
      }
      if (data.hasOwnProperty('time_updated')) {
        obj['time_updated'] = _ApiClient.default.convertToType(data['time_updated'], 'String');
      }
      if (data.hasOwnProperty('deleted_at')) {
        obj['deleted_at'] = _ApiClient.default.convertToType(data['deleted_at'], 'String');
      }
      if (data.hasOwnProperty('deleted_by')) {
        obj['deleted_by'] = _ApiClient.default.convertToType(data['deleted_by'], 'String');
      }
      if (data.hasOwnProperty('date_deleted')) {
        obj['date_deleted'] = _ApiClient.default.convertToType(data['date_deleted'], 'String');
      }
      if (data.hasOwnProperty('time_deleted')) {
        obj['time_deleted'] = _ApiClient.default.convertToType(data['time_deleted'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>SubscriptionType</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SubscriptionType</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of SubscriptionType.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
      throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
    }
    // ensure the json data is a string
    if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
      throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
    }
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['created_by'] && !(typeof data['created_by'] === 'string' || data['created_by'] instanceof String)) {
      throw new Error("Expected the field `created_by` to be a primitive type in the JSON string but got " + data['created_by']);
    }
    // ensure the json data is a string
    if (data['time_created'] && !(typeof data['time_created'] === 'string' || data['time_created'] instanceof String)) {
      throw new Error("Expected the field `time_created` to be a primitive type in the JSON string but got " + data['time_created']);
    }
    // ensure the json data is a string
    if (data['updated_by'] && !(typeof data['updated_by'] === 'string' || data['updated_by'] instanceof String)) {
      throw new Error("Expected the field `updated_by` to be a primitive type in the JSON string but got " + data['updated_by']);
    }
    // ensure the json data is a string
    if (data['time_updated'] && !(typeof data['time_updated'] === 'string' || data['time_updated'] instanceof String)) {
      throw new Error("Expected the field `time_updated` to be a primitive type in the JSON string but got " + data['time_updated']);
    }
    // ensure the json data is a string
    if (data['deleted_by'] && !(typeof data['deleted_by'] === 'string' || data['deleted_by'] instanceof String)) {
      throw new Error("Expected the field `deleted_by` to be a primitive type in the JSON string but got " + data['deleted_by']);
    }
    // ensure the json data is a string
    if (data['time_deleted'] && !(typeof data['time_deleted'] === 'string' || data['time_deleted'] instanceof String)) {
      throw new Error("Expected the field `time_deleted` to be a primitive type in the JSON string but got " + data['time_deleted']);
    }
    return true;
  }
}
SubscriptionType.RequiredProperties = ["sorting_order", "title", "duration", "max_file_size", "max_total_size", "max_uploads", "user_limit", "is_trial", "adscores_accessible", "zoom_meeting_enabled", "id", "created_at", "updated_at"];

/**
 * @member {Number} sorting_order
 */
SubscriptionType.prototype['sorting_order'] = undefined;

/**
 * @member {String} title
 */
SubscriptionType.prototype['title'] = undefined;

/**
 * @member {Number} duration
 */
SubscriptionType.prototype['duration'] = undefined;

/**
 * @member {Number} max_file_size
 */
SubscriptionType.prototype['max_file_size'] = undefined;

/**
 * @member {Number} max_total_size
 */
SubscriptionType.prototype['max_total_size'] = undefined;

/**
 * @member {Number} max_uploads
 */
SubscriptionType.prototype['max_uploads'] = undefined;

/**
 * @member {Number} user_limit
 */
SubscriptionType.prototype['user_limit'] = undefined;

/**
 * @member {Number} price_prepaid
 */
SubscriptionType.prototype['price_prepaid'] = undefined;

/**
 * @member {Number} price_subscription
 */
SubscriptionType.prototype['price_subscription'] = undefined;

/**
 * @member {Boolean} is_trial
 */
SubscriptionType.prototype['is_trial'] = undefined;

/**
 * @member {Boolean} adscores_accessible
 */
SubscriptionType.prototype['adscores_accessible'] = undefined;

/**
 * @member {String} description
 */
SubscriptionType.prototype['description'] = undefined;

/**
 * @member {Boolean} zoom_meeting_enabled
 */
SubscriptionType.prototype['zoom_meeting_enabled'] = undefined;

/**
 * @member {String} id
 */
SubscriptionType.prototype['id'] = undefined;

/**
 * @member {String} created_at
 */
SubscriptionType.prototype['created_at'] = undefined;

/**
 * @member {String} created_by
 */
SubscriptionType.prototype['created_by'] = undefined;

/**
 * @member {String} date_created
 */
SubscriptionType.prototype['date_created'] = undefined;

/**
 * @member {String} time_created
 */
SubscriptionType.prototype['time_created'] = undefined;

/**
 * @member {String} updated_at
 */
SubscriptionType.prototype['updated_at'] = undefined;

/**
 * @member {String} updated_by
 */
SubscriptionType.prototype['updated_by'] = undefined;

/**
 * @member {String} date_updated
 */
SubscriptionType.prototype['date_updated'] = undefined;

/**
 * @member {String} time_updated
 */
SubscriptionType.prototype['time_updated'] = undefined;

/**
 * @member {String} deleted_at
 */
SubscriptionType.prototype['deleted_at'] = undefined;

/**
 * @member {String} deleted_by
 */
SubscriptionType.prototype['deleted_by'] = undefined;

/**
 * @member {String} date_deleted
 */
SubscriptionType.prototype['date_deleted'] = undefined;

/**
 * @member {String} time_deleted
 */
SubscriptionType.prototype['time_deleted'] = undefined;
var _default = exports.default = SubscriptionType;